import LoggerService,{formatTrace} from '../../services/LoggerService';
import INITIAL_STATE from './INITIAL_STATE';
import REDUCER_ACTIONS from './ACTIONS';

const LOG = LoggerService.getInstance();

const reducer = (
  state: any,
  action: any
) => {
	if (action.type === REDUCER_ACTIONS.SET_ROLES) {
		const {roles} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_ROLES',{roles}));
		return {...state,roles};
	}
	if (action.type === REDUCER_ACTIONS.SET_ORGANISATIONS) {
		const {organisations} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_ORGANISATIONS',{organisations}));
		return {...state,organisations};
	}
	if (action.type === REDUCER_ACTIONS.SET_SITES) {
		const {sites} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_SITES',{sites}));
		return {...state,sites};
	}
	if (action.type === REDUCER_ACTIONS.SET_FUNCTIONS) {
		const {functions} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_FUNCTIONS',{functions}));
		return {...state,functions};
	}
	if (action.type === REDUCER_ACTIONS.SET_REFERENTIALS) {
		const {referentials} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_REFERENTIALS',{referentials}));
		return {...state,referentials};
	}
	if (action.type === REDUCER_ACTIONS.SET_PAGINATION_LIMIT) {
		const {pagination_limit} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_PAGINATION_LIMIT',{pagination_limit}));
		return {...state,pagination_limit};
	}
  if (action.type === REDUCER_ACTIONS.SET_ROLES_PER_ENDPOINT) {
    const {roles_per_endpoint} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_ROLES_PER_ENDPOINT',{roles_per_endpoint}));
    return {...state,roles_per_endpoint};
  }

	if (action.type === REDUCER_ACTIONS.SET_INITIALIZATION_OK) {
		const {initializationOK} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_INITIALIZATION_OK',{initializationOK}));
		return {...state,initializationOK};
	}

	if (action.type === REDUCER_ACTIONS.SET_DRAWER_SHOW) {
		const {show} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_DRAWER_SHOW',{show}));
		return {...state,drawerShow:show};
	}
	if (action.type === REDUCER_ACTIONS.SET_SIDEBAR_SHOW) {
		const {show} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_SIDEBAR_SHOW',{show}));
		return {...state,sidebarShow:show};
	}
	if (action.type === REDUCER_ACTIONS.SET_PANEL_ALIGNMENT) {
		const {panelAlignment} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_PANEL_ALIGNMENT',{panelAlignment}));
		return {...state,panelAlignment};
	}
	if (action.type === REDUCER_ACTIONS.SET_PAGINATION_USER_LIMIT) {
		const {paginationUserLimit} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_PAGINATION_USER_LIMIT',{paginationUserLimit}));
		return {...state,paginationUserLimit};
	}

  if (action.type === REDUCER_ACTIONS.SET_ACCESS_TOKEN) {
		const {token} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_ACCESS_TOKEN',{token}));
		return {...state,accessToken:token};
	}
	if (action.type === REDUCER_ACTIONS.SET_REFRESH_TOKEN) {
		const {token} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_REFRESH_TOKEN',{token}));
		return {...state,refreshToken:token};
	}
	if (action.type === REDUCER_ACTIONS.SET_ROLE) {
		const {role} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_ROLE',{role}));
		return {...state,role};
	}
	if (action.type === REDUCER_ACTIONS.SET_FUNCTION) {
		const funct = action.payload?.function;
    LOG.trace(...formatTrace('reducer - SET_FUNCTION',{function:funct}));
		return {...state,function:funct};
	}
	if (action.type === REDUCER_ACTIONS.SET_USER_ID) {
		const {userId} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_USER_ID',{userId}));
		return {...state,userId};
	}
	if (action.type === REDUCER_ACTIONS.SET_USER_POSTPONE_ID) {
		const {id_postpone} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_USER_POSTPONE_ID',{id_postpone}));
		return {...state,id_postpone};
	}
	if (action.type === REDUCER_ACTIONS.SET_SAML_CONNECTING) {
		const {samlConnecting} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_SAML_CONNECTING',{samlConnecting}));
		return {...state,samlConnecting};
	}
	if (action.type === REDUCER_ACTIONS.SET_ORGANISATIONS_SETS) {
		const {organisationsSets} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_ORGANISATIONS_SETS',{organisationsSets}));
		return {...state,organisationsSets};
	}
	// return state;
	throw new Error(`No matching "${action.type}" action type`);
};

export {INITIAL_STATE};
export default reducer;
